import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { WhiteLabelLogo } from '../whiteLabel';

type AuthWrapperProps = {
  pageTitle?: string;
  subtitle?: string;
  children?: ReactNode;
  footer?: ReactNode;
  footerClassName?: string;
  className?: string;
};

export function AuthWrapper(props: Readonly<AuthWrapperProps>) {
  const { pageTitle, subtitle, children, footer, footerClassName, className } =
    props;
  const { t } = useTranslation();

  return (
    <main
      data-theme='light'
      className='flex justify-center h-full w-full overflow-auto lg:pt-0 lg:bg-gradient-to-b lg:from-white lg:to-wl-primary-p20'
    >
      <div className='lg:w-[450px] m-auto'>
        <div className='flex flex-row items-center justify-center pt-14 sm:pt-10 gap-2'>
          <WhiteLabelLogo nameClassName='text-M-32' />
        </div>

        {pageTitle && (
          <h3 className='text-R-22 py-12 sm:py-8 text-center flex items-center justify-center'>
            {t(pageTitle)}
          </h3>
        )}
        <div className=''>
          <div
            className={`lg:bg-white lg:rounded-xl lg:py-8 lg:px-8 px-4 ${className}`}
          >
            {subtitle && (
              <div className='pt-3 flex flex-row gap-2 items-center w-full max-lg:pt-2'>
                <p className='text-gray-600 font-normal text-base'>
                  {t(subtitle)}
                </p>
              </div>
            )}
            <div>{children}</div>
          </div>
        </div>
        <div className={`${footerClassName}`}>{footer}</div>
      </div>
    </main>
  );
}
